export default "__VITE_ASSET__CYEcbdnm__"